const getStateSlice = (state) => state.utility.throttleDispatch;

const selectors = { getStateSlice };

export default selectors;
